// extracted by mini-css-extract-plugin
module.exports = {"button":"FzXHs","icon":"wd52Z","label":"scuED","value":"_6fY1C","time":"_9jLMX","text":"_6cKtG"};